import React, { useEffect, useState } from 'react'
import RoleWiseFeatureWrapper, { checkFeatureAccess } from '../../Lib/RoleWiseFeatureWrapper';
import Select from 'react-select';
import { addWaterJugs, editWaterJugs, getWaterJugs } from '../../Services/WaterJug/action';
import { connect } from 'react-redux';
import ModulesList from '../../Assets/ModulesLiist';
import FeaturesList from '../../Assets/FeaturesList';
import { useNavigate } from 'react-router-dom';
import moment from 'moment/moment';
import Table from '../../Components/Table';
import { deleteRecord } from '../../Services/Delete/action';
import '../../Assets/Css/WaterJug.scss'
import { customStyle } from '../../Components/Style';
import { toast } from 'react-toastify';

const header = [
    { field: "Date" },
    { field: "No. of Jugs" },
    { field: "Action" },
];

const WaterJug = (props) => {

    const currentMonth = moment().month() + 1;
    const currentYear = moment().year();
    const [selectedMonth, setSelectedMonth] = useState({
        value: currentMonth,
        label: moment.months()[currentMonth - 1]
    });
    const [selectedYear, setSelectedYear] = useState({
        value: currentYear,
        label: currentYear
    });
    const [inData, setInData] = useState([]);
    const navigate = useNavigate()

    const [Fields, setFields] = useState({
        today_date: moment().format('YYYY-MM-DD'),
        no_of_jug: 1,
    });

    const canView = checkFeatureAccess({
        modules: props?.modules,
        features: props?.features,
        user: props?.user,
        ModuleName: ModulesList.WaterJug,
        Featur_Name: FeaturesList.View,
    });

    const canDelete = checkFeatureAccess({
        modules: props?.modules,
        features: props?.features,
        user: props?.user,
        ModuleName: ModulesList.WaterJug,
        Featur_Name: FeaturesList.Delete,
    });

    const canEdit = checkFeatureAccess({
        modules: props?.modules,
        features: props?.features,
        user: props?.user,
        ModuleName: ModulesList.WaterJug,
        Featur_Name: FeaturesList.Update,
    });

    const monthOptions = moment.months().map((month, index) => ({
        value: index + 1,
        label: month,
    }));

    const yearOptions = Array.from({ length: 11 }, (_, i) => ({
        value: currentYear - 5 + i,
        label: currentYear - 5 + i,
    }));

    const handleAddToday = async () => {
        try {
            const payload = {
                today_date: Fields.today_date,
                no_of_jug: Fields.no_of_jug,
                user_id: props?.user?.id,
            };

            const existingRecord = props.waterjug?.find(
                (jug) =>
                    moment(jug.today_date).format('YYYY-MM-DD') === Fields.today_date &&
                    jug.user_id === props?.user?.id
            );

            if (existingRecord) {
                toast.warning("Water jug for today is already added!");
                return;
            }

            await props.addWaterJug(payload);
            await props.getWaterJugs();
        } catch (error) {
            console.error("Error adding today's water jug:", error);
            toast.error("Something went wrong");
        }
    };

    useEffect(() => {
        props?.getWaterJugs();
    }, []);

    useEffect(() => {
        const month = selectedMonth?.value;
        const year = selectedYear?.value;
        const filteredData = props.waterjug
            .filter((item) => {
                const itemDate = moment(item.today_date);
                return (
                    itemDate.month() + 1 === month &&
                    itemDate.year() === year
                );
            })
            .reverse();
        setInData(
            filteredData.map((item) => {
                const date = moment(item?.today_date).format("DD-MM-YYYY");
                const noOfJugs = item?.no_of_jug || 1;

                return {
                    "Date": {
                        value: date,
                        type: 'text'
                    },
                    "No. of Jugs": {
                        value: noOfJugs,
                        type: 'waterJugCounter'
                    },
                    Action: {
                        value2: '/waterjug/view',
                        value: '/waterjug/edit',
                        value3: item?.id,
                        value9: "",
                        type: 'action'
                    },
                    allData: { ...item }
                };
            })
        );
    }, [props?.waterjug, selectedMonth, selectedYear]);

    const handleClear = () => {
        setSelectedMonth({
            value: currentMonth,
            label: moment.months()[currentMonth - 1]
        });
        setSelectedYear({
            value: currentYear,
            label: currentYear
        });
    };

    return (
        <div className='water-jug-container mb-5'>
            <div className="page-title">
                <h4>Water Jug</h4>
                <div className='d-flex gap-3'>
                    <RoleWiseFeatureWrapper
                        modules={props?.modules}
                        features={props?.features}
                        user={props?.user}
                        ModuleName={ModulesList.WaterJug}
                        Featur_Name={FeaturesList.Create}
                    >
                        <button
                            className="export-btn"
                            id="exportBtn"
                            onClick={handleAddToday}
                        >
                            Add today
                        </button>
                    </RoleWiseFeatureWrapper>
                    <RoleWiseFeatureWrapper
                        modules={props?.modules}
                        features={props?.features}
                        user={props?.user}
                        ModuleName={ModulesList.WaterJug}
                        Featur_Name={FeaturesList.Create}
                    >
                        <button
                            className="export-btn"
                            id="exportBtn"
                            onClick={(e) => {
                                navigate("/waterjug/add")
                            }}
                        >
                            Add
                        </button>
                    </RoleWiseFeatureWrapper>
                </div>
            </div>

            {
                location.pathname === "/waterjug" && (
                    <div className='water-jug-filters'>
                        <div className='input-main'>
                            <div className="input-group">
                                <Select
                                    options={monthOptions}
                                    styles={{
                                        ...customStyle,
                                        menu: (provided) => ({
                                            ...provided,
                                            zIndex: 2,
                                        }),
                                    }}
                                    value={selectedMonth}
                                    onChange={(val) => setSelectedMonth(val)}
                                    theme={(theme) => ({
                                        ...theme,
                                        colors: {
                                            ...theme.colors,
                                            primary25: "#5757fe",
                                            primary: "#5757fe",
                                        },
                                    })}
                                    placeholder="Month"
                                />
                            </div>
                            <div className="input-group">
                                <Select
                                    options={yearOptions}
                                    styles={{
                                        ...customStyle,
                                        menu: (provided) => ({
                                            ...provided,
                                            zIndex: 2,
                                        }),
                                    }}
                                    value={selectedYear}
                                    onChange={(val) => setSelectedYear(val)}
                                    theme={(theme) => ({
                                        ...theme,
                                        colors: {
                                            ...theme.colors,
                                            primary25: "#5757fe",
                                            primary: "#5757fe",
                                        },
                                    })}
                                    placeholder="Year"
                                />
                            </div>
                            <div className='add-water-jug input-group'>
                                {
                                    (selectedMonth.value !== currentMonth || selectedYear.value !== currentYear) && (
                                        <div className="add-water-jug-button">
                                            <button className="custom-btn" onClick={handleClear}>
                                                Reset
                                            </button>
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                )
            }

            <div className='ticket-table col-lg-12 col-md-12 col-sm-12'>
                <Table
                    header={header}
                    data={inData}
                    footer={true}
                    showIsView={canView}
                    showIsEdit={canEdit}
                    showIsDelete={canDelete}
                    count={inData?.length}
                    records={inData?.length}
                    loading={props.loading}
                    deleteRecord={props?.deleteRecord}
                    editWaterJugs={props.editWaterJugs}
                    getWaterJugs={props.getWaterJugs}
                />
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        loading: state.waterJugReducer.loading,
        waterjug: state.waterJugReducer.waterjug,
        modules: state.authenticationReducer.modules,
        features: state.authenticationReducer.features,
        user: state.authenticationReducer.user,
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        getWaterJugs: () => {
            dispatch(getWaterJugs())
        },
        deleteRecord: async (id, inputValue) => {
            await dispatch(deleteRecord(id, inputValue))
            await dispatch(getWaterJugs());
        },
        editWaterJugs: (id, updatedData) => dispatch(editWaterJugs(id, updatedData)),
        addWaterJug: (data) => dispatch(addWaterJugs(data)),
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(WaterJug);  